import Swiper from 'swiper';
import SwiperCore, { Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Scrollbar]);
import debounce from 'lodash/debounce';

export default class LogoGrid {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * logo grid element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.swiperInit = false;
        this.sliderElement = sliderElement;
        this.wrapper = this.sliderElement.querySelector('.js-swiper-wrapper');
        this.slides = this.sliderElement.querySelectorAll('.js-swiper-slide');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.navContainer = this.sliderElement.querySelector('.js-nav-container');

        this.handleSwiperInit();

        const debouncedSwiperInit = debounce(() => {
            this.handleSwiperInit();
        }, 100);

        window.addEventListener('resize', () => {
            debouncedSwiperInit();
        });
    }

    handleSwiperInit() {
        if (window.innerWidth < 1024) {
            this.swiper = new Swiper(this.sliderElement, {
                slidesPerView: 2.2,
                spaceBetween: 10,
                watchOverflow: true,
                init: false,
                scrollbar: {
                    el: this.scrollbar,
                    draggable: true
                },
                breakpoints: {
                    768: {
                        spaceBetween: 14,
                        slidesPerView: 3.2
                    }
                }
            })
            
            if (!this.wrapper.classList.contains('swiper-wrapper')) {
                this.sliderElement.classList.add('swiper');
                this.wrapper.classList.add('swiper-wrapper');
                this.slides.forEach(slide => {
                    slide.classList.add('swiper-slide');
                });
            }

            this.swiper.init();
            this.swiperInit = true
        } else {
            if (this.wrapper.classList.contains('swiper-wrapper')) {
                this.sliderElement.classList.remove('swiper');
                this.wrapper.classList.remove('swiper-wrapper');
                this.slides.forEach(slide => {
                    slide.classList.remove('swiper-slide');
                });
            }

            if (this.swiperInit) {
                this.swiper.destroy(false, true);
                this.swiperInit = false
            }
        }
    }
}
